const authState = (state) => state.auth

export const authSelectors = {
    username: (state) => authState(state).username,
    isAuthorized: (state) => authState(state).isAuthorized,
    isLoading: (state) => authState(state).isLoading,
    error: (state) => authState(state).error,
}
